import { Formik } from "formik";
import { FocusEvent, useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import AutocompleteV2 from "../../../component/AutocompleteObjectV2";
import FormInPhieuDialog from "../../../component/button-in-phieu/components/PrintDialog";
import { TableCollapseCustom } from "../../../component/table/table-collapse/TableCollapseCustom";
import TextField from "../../../component/TextField";
import { CODE } from "../../../utils/Constant";
import WfContextMenu from "../../../workflows/components/WfContextMenu";
import { WfConstTracker } from "../../../workflows/Constant";
import { convertListDichVuXetNgiem, genderClassName } from "../../common";
import { DATA_TYPE_XN, WF_STEP } from "../../const/constants";
import { PhanHeXetNghiemContext } from "../../context/PhanHeXetNghiemContext";
import {
  getPhieuXetNghemInfo,
  inKetQuaDichVu,
  saveObsValue,
} from "../../service/tiepNhan";
import { getObsComplexCategories } from "../../../phan-he-danh-muc/DanhMucServices";
import { TERM_MODEL_TYPE } from "../../../phan-he-danh-muc/const/constant";
import { RESPONSE_STATUS_CODE } from "../../../auth/core/_consts";
import { getErrorMessage } from "../../../utils/FormatUtils";
import OctTooltip from "../../../component/tooltip";
import CellFormatter from "../../../component/cell-formatter";
import clsx from "clsx";
import { getWorkflowTrackerFieldConfig } from "../../../workflows/utils";

const BangDsDichVuXN = ({
    actionClick,
    rowSelect,
    setRowSelect,
    listPreviousResult,
    updateTestData
}: any) => {
  const { benhNhanInfo, phieuXetNghiemInfo, setPhieuXetNghiemInfo } =
		useContext(PhanHeXetNghiemContext);

  const [contextMenu, setContextMenu] = useState<null | {
    x: number;
    y: number;
  }>(null);
  const [dataKQ, setDataKQ] = useState<any>([]);
  const [fieldLoading, setFieldLoading] = useState<any>({});
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
  const [selectedColIndex, setSelectedColIndex] = useState<number | null>(null);
  const [openPrintDialog, setOpenPrintDialog] = useState(false);
  const [itemService, setItemService] = useState<any>(null);
  const [dsMayXN, setDsMayXN] = useState<any[]>([]);

  const resultCellRef = useRef<HTMLDivElement>(null);

  const COMPONENT_NAME = 'BangDsDichVuXN';

  useEffect(() => {
    handleGetDsMayXN();
  }, []);

  useEffect(() => {
    setDataKQ(phieuXetNghiemInfo?.dsXetNghiem || []);
  }, [phieuXetNghiemInfo]);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (selectedRowIndex && !event?.target?.closest(".textfield-container")) {
        setSelectedRowIndex(null);
        setItemService(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectedRowIndex]);

  useEffect(() => {
    setSelectedRowIndex(null);
  }, [benhNhanInfo?.testGroupId]);

  const handleGetDsMayXN = async () => {
    try {
      const { data } = await getObsComplexCategories(TERM_MODEL_TYPE.MD_THIET_BI);
      if (CODE.SUCCESS === data?.code) {
        setDsMayXN(data?.data || []);
      }
    } catch (error) {
      console.error(error)
    }
  };

  const handleGetDsDichVu = async () => {
    const { data: dataXN } = await getPhieuXetNghemInfo(
      benhNhanInfo?.testGroupId
    );
    if (CODE.SUCCESS === dataXN?.code) {
      const thongTinPhieu = dataXN?.data;
      const dsXetNghiem = convertListDichVuXetNgiem(thongTinPhieu.ordersList);
      setPhieuXetNghiemInfo({
        thongTinPhieu,
        dsXetNghiem,
      });
    }
  };

  const handleSaveObs = async (rowData: any, value: any, isMayXN?: boolean) => {
    try {
      if (value !== rowData.obs?.value) {
        setFieldLoading({ [rowData.id]: true });
        const submitData = {
          personId: benhNhanInfo?.patient?.personId,
          termId: rowData.termId || rowData.id,
          orderId: rowData?.orderId,
          ...(
            isMayXN
              ? {
                paraclinicalMachineCode: value?.tbDeviceCode,
                paraclinicalMachineName: value?.tbDeviceName,
                value: rowData.obs?.value
              }
              : {
                value: value.id || value,
                paraclinicalMachineCode: rowData.obs?.paraclinicalMachineCode,
                paraclinicalMachineName: rowData.obs?.paraclinicalMachineName,
              }
          ),
        };

        const { data } = await saveObsValue(submitData);
        if (data?.code >= RESPONSE_STATUS_CODE.BAD_REQUEST) {
           toast.error(getErrorMessage(data));
           return;
        }

        await handleGetDsDichVu();
      }
    } catch (error) {
      console.error(error);
      toast.warning("Lỗi lưu kết quả, vui lòng nhập lại!");
    } finally {
      setFieldLoading({});
    }
  };

  const generateInput = (rowData: any) => {
    let dataType = rowData?.term?.datatypeId || rowData?.datatypeId;
    let isTestStart =
      phieuXetNghiemInfo.thongTinPhieu.state.currStatusCode ===
      WF_STEP.TEST_START;
    switch (dataType) {
      case DATA_TYPE_XN.TEXT:
        return (
          <div className="textfield-container d-flex align-items-center w-100">
            <TextField
              className="w-100"
              inputClassName="w-100"
              type="text"
              name="obsValue"
              defaultValue={rowData?.obs?.value || ""}
              disabled={!isTestStart}
              onBlur={(e: FocusEvent<HTMLInputElement>) => {
                if (
                  e?.target?.value !== rowData?.obs?.value &&
                  (e?.target?.value || rowData?.obs?.value)
                ) {
                  handleSaveObs(rowData, e?.target?.value);
                  setSelectedRowIndex(null);
                }
              }}
              autoFocus={true}
              containerClassName="editable-cell"
            />
            {fieldLoading[rowData.id] && (
              <span className="loading-spinner"></span>
            )}
          </div>
        );
      case DATA_TYPE_XN.DATETIME:
      case DATA_TYPE_XN.DATE:
        return (
          <div className="d-flex align-items-center">
            <input
              type={
                dataType === DATA_TYPE_XN.DATETIME ? "datetime-local" : "date"
              }
              className="w-100"
              defaultValue={rowData?.obs?.value || ""}
              disabled={!isTestStart}
              onBlur={(e) => {
                handleSaveObs(rowData, e.target.value);
              }}
            />
            {fieldLoading[rowData.id] && (
              <span className="loading-spinner"></span>
            )}
          </div>
        );
      case DATA_TYPE_XN.BOOLEAN:
        return (
          <div className="d-flex align-items-center justify-content-center">
            <input
              type="checkbox"
              className="form-check-input"
              defaultChecked={rowData?.obs?.value === "true"}
              disabled={!isTestStart}
              onChange={(e) => {
                handleSaveObs(rowData, e.target.checked);
              }}
            />
            {fieldLoading[rowData.id] && (
              <span className="loading-spinner"></span>
            )}
          </div>
        );
      case DATA_TYPE_XN.NUMERIC:
        return (
          <div className="textfield-container d-flex align-items-center w-100">
            <TextField
              className="w-100"
              inputClassName="w-100"
              type="number"
              name="obsValue"
              defaultValue={rowData?.obs?.value || ""}
              disabled={!isTestStart}
              onBlur={(e: FocusEvent<HTMLInputElement>) => {
                if (
                  +e?.target?.value !== +rowData?.obs?.value &&
                  (e?.target?.value || rowData?.obs?.value)
                ) {
                  handleSaveObs(rowData, e?.target?.value);
                  setSelectedRowIndex(null);
                }
              }}
              autoFocus={true}
              containerClassName="editable-cell"
            />
            {fieldLoading[rowData.id] && (
              <span className="loading-spinner"></span>
            )}
          </div>
        );
      case DATA_TYPE_XN.CODE:
      case DATA_TYPE_XN.PARENT_CODE:
        return (
          <div className="textfield-container d-flex align-items-center">
            <AutocompleteV2
              options={rowData?.answers || []}
              value={rowData?.answers.find(
                (item: any) => item.name === rowData?.obs?.value
              )}
              name="obsValue"
              valueField="name"
              onChange={(selectedOption) => {
                handleSaveObs(rowData, selectedOption);
                setSelectedRowIndex(null);
              }}
              isDisabled={!isTestStart}
              className="autocomplete-custom-tiep-nhan radius spaces width-100 h-25"
            />
            {fieldLoading[rowData.id] && (
              <span className="loading-spinner"></span>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  const columnThongTinXetNghiem = [
    {
      title: "Mã DV",
      field: "code",
      className: "spaces width-11 text-center",
      render: (rowData: any) => {
        return <CellFormatter rowData={rowData} value={rowData?.code} />;
      },
    },
    {
      title: "Tên xét nghiệm",
      field: "name",
      className: "spaces width-30",
      render: (rowData: any) => {
        return <CellFormatter rowData={rowData} value={rowData?.name} />;
      },
    },
    {
      title: "Kết Quả",
      field: "obs.value",
      className: "spaces width-13 text-center px-0",
      render: (rowData: any, listIndex: any[], colIndex: number) => {
        const isEnableField = getFieldAttributes(rowData, 'obsValue')?.write;

        return (
          <Formik initialValues={{}} onSubmit={() => {}}>
            {
              selectedRowIndex === rowData?.id && 
              selectedColIndex === colIndex && 
              isEnableField &&
              !rowData?.subs?.length
              ? generateInput(rowData)
              : (
              <div
                className={clsx(
                  'spaces min-h-30 d-flex align-items-center justify-content-center',
                   genderClassName(rowData)
                )}
                onClick={async () => {
                  setSelectedRowIndex(rowData?.id);
                  setSelectedColIndex(colIndex);
                }}
                ref={resultCellRef}
              >
                  <OctTooltip title={rowData?.obs?.value}>
                    <span 
                      className="text-ellipsis"
                      style={{
                        maxWidth: resultCellRef.current?.clientWidth
                      }}
                    > 
                      {rowData?.obs?.value}
                    </span>
                  </OctTooltip>
              </div>
            )}
          </Formik>
        );
      },
    },
    {
      title: "KQ cũ",
      field: "obs.value",
      className: "spaces width-11 text-center",
      render: (rowData: any) => {
        let res: any = listPreviousResult?.find(
          (item: any) => item?.id === rowData?.id
        );
        return (
          <CellFormatter 
            rowData={rowData} 
            value={res?.value} 
          />
        );
      },
    },
    {
      title: "",
      field: "HL",
      className: "spaces width-4 text-center",
      render: (rowData: any) => {
        const validValue = (value: any) => {
          return value || value === 0;
        };
        let isText = rowData?.datatypeId === DATA_TYPE_XN.TEXT;
        let lowNormal = rowData?.numeric?.lowNormal;
        let hiNormal = rowData?.numeric?.hiNormal;
        let value = rowData?.obs?.value;
        let result = "";
        if (validValue(value) && validValue(hiNormal) && value > hiNormal) {
          result = "H";
        } else if (
          validValue(value) &&
          validValue(lowNormal) &&
          value < lowNormal
        ) {
          result = "L";
        }
        return !isText ? (
          <CellFormatter rowData={rowData} value={result} />
        ) : (
          <></>
        );
      },
    },
    {
      title: "Đơn vị",
      field: "donVi",
      className: "spaces width-6 text-center",
      render: (rowData: any) => {
        return (
          <CellFormatter 
            rowData={rowData} 
            value={rowData?.numeric?.units} 
          />
        )
      },
    },
    {
      title: "GTBT",
      field: "gtbt",
      className: "spaces width-6 text-center",
      render: (rowData: any) => {
        let isText = rowData?.datatypeId === DATA_TYPE_XN.TEXT;
        const validValue = (value: any) => {
          return value || value === 0;
        };
        let result = "";
        let lowNormal = rowData?.numeric?.lowNormal;
        let hiNormal = rowData?.numeric?.hiNormal;
        if (isText) {
          result = rowData?.numeric?.label || "";
        } else if (validValue(lowNormal) && validValue(hiNormal)) {
          result =
            lowNormal === hiNormal ? lowNormal : lowNormal + " - " + hiNormal;
        } else if (validValue(lowNormal) && !validValue(hiNormal)) {
          result = "> " + lowNormal;
        } else if (!validValue(lowNormal) && validValue(hiNormal)) {
          result = "< " + hiNormal;
        }
        return (
          <CellFormatter 
            rowData={rowData} 
            value={result} 
          />
        )
      },
    },
    { 
      title: "Loại bệnh phẩm", 
      field: "type", 
      className: "spaces width-10",
      render: (rowData: any) => {
        return <CellFormatter rowData={rowData} value={rowData?.type} />;
      }
    },
    {
      title: "Máy XN",
      field: "description",
      className: "spaces width-10",
      render: (rowData: any, _: any, colIndex: number) => {
        const isEnableField = getFieldAttributes(rowData, 'paraclinicalMachine')?.write;
        const value = rowData?.obs?.paraclinicalMachineCode
        ? {
            tbDeviceCode: rowData?.obs?.paraclinicalMachineCode,
            tbDeviceName: rowData?.obs?.paraclinicalMachineName,
          }
        : null;

        return (
          <Formik initialValues={{}} onSubmit={() => { }}>
            {
              selectedRowIndex === rowData?.id && 
              selectedColIndex === colIndex &&
              isEnableField
            ? (
              <div 
                role="button"
                className="textfield-container d-flex align-items-center editable-cell"
                onClick={(e) => e.stopPropagation()}
              >
                <AutocompleteV2
                  options={dsMayXN}
                  value={value}
                  name="paraclinicalMachine"
                  valueField="tbDeviceName"
                  onChange={(selectedOption) => {
                    handleSaveObs(rowData, selectedOption, true);
                    setSelectedRowIndex(null);
                  }}
                  getOptionLabel={(option: any) => option?.tbDeviceName}
                  getOptionValue={(option: any) => option?.tbDeviceCode}
                />
                {fieldLoading[rowData.id] && (
                  <span className="loading-spinner"></span>
                )}
              </div>
            ) : (
              <CellFormatter 
                rowData={rowData}
                value={rowData?.obs?.paraclinicalMachineName}
                className={clsx('spaces min-h-30 d-flex align-items-center justify-content-center')}
                onClick={() => {
                  setSelectedRowIndex(rowData?.id)
                  setSelectedColIndex(colIndex);
                }}
              />
            )}
          </Formik>
        )
      }
    },
  ];

  const handleClearContext = () => {
    setContextMenu?.(null);
  };

  const handleContextMenu = async (e: any, row: any) => {
    e.preventDefault();
    try {
      if(row?.term?.id){
        setRowSelect(row);
        setItemService(row)
        setContextMenu({ x: e.clientX, y: e.clientY });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setFieldLoading({});
    }
  };

  const actionChanged = (currStatusCodeUpdate: string | undefined) => {
    // if (currStatusCodeUpdate !== currStatusCode) {
    //   setCurrentStatusCode(currStatusCodeUpdate);
    //   switch (currStatusCodeUpdate) {
    //     case WF_STEP.TEST_OBS_RESULT:
    //     case WF_STEP.TEST_ORDER_RESULT:
    //       toast.success("Trả kết quả thành công");
    //       break;
    //     case WF_STEP.TEST_OBS_START:
    //     case WF_STEP.TEST_ORDER_START:
    //       toast.success("Hủy trả kết quả thành công");
    //       break;
    //   }
    // }
    updateTestData();
    handleClearContext();
    setItemService(null);
  };

  const getFieldAttributes = (rowData: any, field: string) => {
		return getWorkflowTrackerFieldConfig({
			workflowConfig: rowData?.additionalConfiguration,
			componentName: COMPONENT_NAME,
			field,
		});
  };

  return (
    <>
      <TableCollapseCustom
        columns={columnThongTinXetNghiem}
        data={dataKQ || []}
        className="overflow-auto spaces h-calc-vh-350"  
        classNameTable="spaces W-1000"
        childrenField="subs"
        handleContextMenu={handleContextMenu}
        isFromTabXN
      />

      {contextMenu && itemService && !rowSelect?.isCanceled && (
        <WfContextMenu
          handleCloseMenu={() => {
            handleClearContext();
          }}
          target={contextMenu}
          tracker={WfConstTracker.TEST_ORDER}
          objectId={itemService?.termOrderId}
          className="context-menu-xn"
          additionalFunc={actionChanged}
          handleClick={(data) => {
            actionClick(data);
          }}
          componentName="BangDsDichVuXN"
          additionalProps={{
            termId: itemService?.termId,
            testGroupId: itemService?.testGroupId,
          }}
        />
      )}

      {openPrintDialog && (
        <FormInPhieuDialog
          show={openPrintDialog}
          onHide={() => {
            setOpenPrintDialog(false);
          }}
          fetchExport={inKetQuaDichVu}
          params={{
            orderTermId: rowSelect?.termId,
            testGroupId: benhNhanInfo?.testGroupId,
          }}
        />
      )}
    </>
  );
};

export default BangDsDichVuXN;
